import React from 'react';

import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

import EmojiRotator from './EmojiRotator.jsx';
import systemHelper from './../helpers/system';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';


const LandingSlide = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'LandingSlide',


  /**
   * Timeout to show emojis
   */
  showTimeout: 0,


  /**
   * Ball position object
   */
  ballPosition: { y: 0 },


  /**
   * Expected propTypes
   * @prop {Boolean} active - If this is the current active slide
   * @prop {Function} clickHandler - A click handler
   * @prop {Object} cssTransforms3d - Whether the browser
   * supports css 3d transforms
   * @prop {Object} descriptionData - The site description data
   * @prop {Number} height - The height for the slide's style
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Boolean} next - If this is the next from the active slide
   * @prop {Boolean} prev - If this is the previous from the active slide
   * @prop {Boolean} touch - If browser supports touch events
   * @prop {Number} yPosition - The top position for the slide's style
   */
  propTypes: {
    active: React.PropTypes.bool,
    clickHandler: React.PropTypes.func,
    cssTransforms3d: React.PropTypes.bool,
    descriptionData: React.PropTypes.object,
    height: React.PropTypes.number,
    large: React.PropTypes.bool.isRequired,
    next: React.PropTypes.bool,
    prev: React.PropTypes.bool,
    touch: React.PropTypes.bool,
    yPosition: React.PropTypes.number,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      refreshWindowSize: false,
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    setTimeout(() => {
      this.setState({ refreshWindowSize: true });
    }, 20);
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const description = this._renderDescription();
    const approximateEmojiWidth = !this.props.large ? 30 : 50;
    const approximateEmojiHeight = !this.props.large ? 30 : 50;
    const totalCols = Math.floor(window.innerWidth / approximateEmojiWidth);
    const totalRows = Math.floor(window.innerHeight / approximateEmojiHeight);
    const emojiWidth = window.innerWidth / totalCols;
    const emojiHeight = window.innerHeight / totalRows;
    const prevClass = this.props.prev ? ' prev' : '';
    const activeClass = this.props.active ? ' active' : '';
    const nextClass = this.props.next ? ' next' : '';
    const className = 'component-landing-slide slide' +
      prevClass +
      activeClass +
      nextClass;

    let titleColAmount = Math.round(totalCols / 3);
    if (((totalCols - titleColAmount) / 2) % 1 !== 0) {
      titleColAmount += 1;
    }

    let titleRowAmount = this.props.large ? Math.round(totalRows / 3) : Math.round(totalRows / 4);
    if (((totalRows - titleRowAmount) / 2) % 1 !== 0) {
      titleRowAmount += 1;
    }

    const titleWidth = (emojiWidth * titleColAmount);
    const titleHeight = (emojiHeight * titleRowAmount);
    const titleLeft = ((totalCols - titleColAmount) / 2) * emojiWidth;
    const titleTop = ((totalRows - titleRowAmount) / 2) * emojiHeight;
    const titleTextHeight = this.props.large ? 70 : 60;
    const descriptionTextHeight = this.refs.description ? this.refs.description.offsetHeight : 0;
    let titlePaddingTop = ((titleHeight / 2) -
      ((titleTextHeight + descriptionTextHeight) / 2)) + 5;
    if (this.props.large) {
      titlePaddingTop = ((titleHeight / 2) -
        ((titleTextHeight + descriptionTextHeight - 60) / 2)) + 5;
    }

    const clickHandler = (this.props.large && !this.props.touch) ? this._onClick : this.props.clickHandler;
    let touchEndHandler = this.props.touch ? this.props.clickHandler : null;
    if (this.props.large && this.props.touch) {
      touchEndHandler = this._onClick;
    }

    const emojiRotator = this._renderEmojiRotator();


    const style = {
      height: this.props.height,
      top: this.props.yPosition,
    };

    const titleStyle = {
      top: titleTop,
      left: titleLeft,
      height: titleHeight,
      width: titleWidth,
      paddingTop: titlePaddingTop,
    };

    return (
      <div
        style={style}
        className={className}
        onClick={clickHandler}
        onTouchEnd={touchEndHandler}
      >
        {emojiRotator}
        <div style={titleStyle} className='title-wrapper'>
          <div ref='title' className='title'>
            <div className='t1'>
              <span>EM</span>
              <span className='ball'>🏀</span>
              <span>JI</span>
            </div>
            <div className='t2'>IS LIFE</div>
          </div>
          <div ref='description' className='description-wrapper'>
            {description}
          </div>
        </div>
      </div>
    );
  },


  _renderEmojiRotator() {
    let emojiRotator;

    if (!systemHelper.isFirefox()) {
      emojiRotator = (
        <EmojiRotator
          large={this.props.large}
          active={this.props.active}
          paused={!this.props.active}
        />
      );
    }

    return emojiRotator;
  },


  /**
   * Renders the large description
   * @returns {ReactElement} A ReactElement
   */
  _renderDescription() {
    let description;

    if (this.props.large) {
      description = (
        <div className='description'>
          <div className='text l1'>{this.props.descriptionData.text}</div>
          <div className='text l2'>ENTER</div>
        </div>
      );
    } else {
      description = (
        <div className='description'>
          <div className='text l2'>ENTER</div>
        </div>
      );
    }

    return description;
  },


  /**
   * Click handler
   * @returns {undefined} undefined
   */
  _onClick() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.GO_TO_MAIN_CONTENT,
    });

    AppDispatcher.handleViewAction({
      actionType: AppConstants.SLIDE_CHANGED,
      slide: 2,
    });

    setTimeout(() => {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.REMOVE_LARGE_LANDING,
      });

      AppDispatcher.handleViewAction({
        actionType: AppConstants.SECTION_TRANSITION_COMPLETE,
      });
    }, 600);
  },
});

export default LandingSlide;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/LandingSlide.jsx
 **/